// React
import React from "react";
// React
// CSS
import styles from "./TicketCard.module.css";
import { I_Ticketanswer } from "../../../../../../Models/interfaces";
import { urlRegex, urlRegex2 } from "../../../../../../constants/constants";
// CSS

type TicketCardProps = {
  data: I_Ticketanswer;
};

const TicketCard: React.FunctionComponent<TicketCardProps> = ({
  data: { created_at, files, id, is_admin, text, user },
}) => {
  return (
    <div
      key={id}
      style={{
        background: is_admin === 1 ? "rgb(236,206,255)" : "rgb(244,244,244)",
      }}
      className={`${styles.ticketCard} w-full p-2 pb-0.5 flex flex-col items-end `}
    >
      <div className={`${styles.top}`}>{is_admin === 1 ? "پشتیبان" : user}</div>
      <div className={`${styles.mid} flex flex-col items-end w-full`}>
        <div
          className=""
          style={{
            direction: "rtl",
          }}
        >
          {text
            .replace("\r", " ")
            .replace("\rg", " ")
            .replace("\n", " ")
            .replace("\ng", " ")
            .replace(/\.\r\n\r\\/g, "")
            .split(/\s+/)
            .map((_i, _index) => {
              if (urlRegex.test(_i) || urlRegex2.test(_i)) {
                return (
                  <a
                    href={_i.startsWith("https://") ? _i : `https://${_i}`}
                    key={_index}
                    className="text-blue-500"
                    target="_blank"
                    rel="noreferrer"
                  >
                    {_i}{" "}
                  </a>
                );
              } else {
                return <React.Fragment key={_index}>{_i} </React.Fragment>;
              }
            })}
          <br />
          <br />
          <br />
        </div>
        {files.map((item, index) => (
          <a
            href={item.path}
            target="_blank"
            key={Math.random() * 1200000}
            rel="noreferrer"
            className="px-8 py-1 bg-purple-400 text-white rounded-lg mt-2 w-1/2 flex items-center justify-center"
          >
            فایل {index + 1}
          </a>
        ))}
      </div>
      <div className={`${styles.bot} w-full`}>
        <span>{created_at}</span>
      </div>
    </div>
  );
};

export default TicketCard;
